import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class PerformanceScoresProvider extends HttpRequest {
  getItems (query) {
    this.setHeader(getAuthToken())
    return this.get('performance-scores', query)
  }

  getItemById (id) {
    this.setHeader(getAuthToken())
    return this.get(`performance-scores/${id}`)
  }

  getItemByWarehouseId (id, month, year) {
    this.setHeader(getAuthToken())
    return this.get(`performance-scores/${id}/warehouse?month=${month}&year=${year}`)
  }

  createItem (payload) {
    this.setHeader(getAuthToken())
    return this.post('performance-scores', payload)
  }

  updateItem (payload) {
    this.setHeader(getAuthToken())
    return this.put(`performance-scores/${payload.id}`, payload)
  }

  updateStatusItem (id, payload) {
    this.setHeader(getAuthToken())
    return this.put(`performance-scores/${id}/status`, payload)
  }

  deleteItem (id) {
    this.setHeader(getAuthToken())
    return this.delete(`performance-scores/${id}`)
  }
}

export default PerformanceScoresProvider
